import ThumbList from './ThumbList';

export default ThumbList;
